import * as Sentry from '@sentry/nuxt';

Sentry.init({
    dsn: process.env.NUXT_SENTRY_DSN,
    environment: process.env.APP_ENV,
    enabled: process.env.APP_ENV === 'production',
    tracesSampleRate: 1.0,
});
